import React, { Fragment, useContext, useEffect, useMemo } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function TodaysEnquiries(props) {
  const { todayEnquiries, tableLists, reservationLoading } =
    useContext(AppContext);

  const parseItem = (item) => {
    return item && typeof item === "string" ? JSON.parse(item) : item;
  };

  useEffect(() => {
    todayEnquiries &&
      todayEnquiries.length != 0 &&
      todayEnquiries.map((item) => {
        const tableData = item?.tables;
        if (!tableData) return;

        let parsedTablles = parseItem(tableData);

        if (parsedTablles && typeof parsedTablles == "string")
          parseItem(parsedTablles);

        if (parsedTablles && parsedTablles.length != 0) {
          const tableNames =
            Array.isArray(parsedTablles) &&
            parsedTablles.map((table) => {
              const tableInfo =
                tableLists && tableLists.find((t) => t.id == table);

              return tableInfo ? tableInfo : null;
            });
          item.tablesDetails = tableNames;
        } else {
          item.tablesDetails = null;
        }
      });
  }, [todayEnquiries, tableLists]);

  const filteredData = useMemo(() => {
    if (!todayEnquiries || todayEnquiries.length === 0) return [];
    const kw = (props.keyword || "").toLowerCase();
    if (!kw) return todayEnquiries;
    return todayEnquiries.filter(
      (item) =>
        item.name.toLowerCase().includes(kw) ||
        item.email.toLowerCase().includes(kw) ||
        item.formattedID.toLowerCase().includes(kw) ||
        item.phone.includes(props.keyword)
    );
  }, [todayEnquiries, props.keyword]);

  return (
    <Fragment>
      <EnquiryListPanel
        title="Today's reservations"
        items={filteredData}
        loading={reservationLoading}
        emptyMessage="No Enquiries Today"
        showStatus
      />
    </Fragment>
  );
}

export default TodaysEnquiries;
